var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2983)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_2983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 6H14C11.7909 6 10 7.79086 10 10V28C10 30.2091 11.7909 32 14 32H32C34.2091 32 36 30.2091 36 28V10C36 7.79086 34.2091 6 32 6Z",
    fill: "#A92C2C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32 2H14C11.7909 2 10 3.79086 10 6V24C10 26.2091 11.7909 28 14 28H32C34.2091 28 36 26.2091 36 24V6C36 3.79086 34.2091 2 32 2Z",
    fill: "#F13838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8721 18.095H19.7221V16.595L22.7221 9.5H24.5221V16.595H25.3021V18.095H24.5221V20H22.8721V18.095ZM22.8721 16.595V12.5H22.8421L21.2221 16.595H22.8721Z",
    fill: "#111820"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_2983",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2983"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2983",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.cf100418deaffe1c1110a2c304d6b423.svg";
export { ForwardRef as ReactComponent };